import fetch from './fetch'

export default {
  getAssessmentsCount (payload) {
    let request = fetch({
      url: `/model/assessment/count`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getAssessments (payload) {
    let request = fetch({
      url: `/assessment/`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getAssessment (payload) {
    let request = fetch({
      url: `/assessment/`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  createAssessment (payload) {
    let request = fetch({
      url: `/assessment/`,
      method: 'post',
      data: payload || {}
    })
    return request.call()
  },
  updateAssessment (payload) {
    const assessmentId = payload._id
    const toOmit = [
      'id',
      '_id',
      'person_id',
      'sharingRecords',
      'sharingGroups',
      'createdAt',
      'createdBy',
      'timestamp',
      'updatedAt',
      'createdAt'
    ]
    const data = _.omit(payload, toOmit)

    // Flatten our associations
    const associations = [
      'createdBy',
      'updatedBy',
      'person',
      'organization',
      'organizationCreator',
      'organizationOwner'
    ]

    _.each(associations, function (assoc) {
      // We forgot to flatten our assocation(s)
      if (data[assoc] && _.isObject(data[assoc])) {
        data[assoc] = data[assoc].id
      } else {
        delete data[assoc]
      }
    })

    let request = fetch({
      url: `/assessment/` + assessmentId,
      method: 'patch',
      data: data
    })

    return request.call()
  }
}



// WEBPACK FOOTER //
// ./src/api/assessment.js